<template>
  <div
    class="factory-product-item"
  >
    <div class="factory-product-item__thumbnail">
      <Image
        class="factory-product-item__image"
        :src="item.imageUrl"
      />
    </div>
    <div class="factory-product-item__content">
      <p class="factory-product-item__title">
        {{ item.subjectTrans }}
      </p>
      <div class="factory-product-item__cell">
        <p class="factory-product-item__price">
          <IntlCurrency
            :currency="currency.current.targetCurrency"
          />
          {{ productPrice(item) }}
        </p>
        <p class="factory-product-item__sold">
          {{ formatSalesVolume(item.monthSold) }} sold
        </p>
      </div>
    </div>
    <div
      class="factory-product-item-top"
      v-if="item.salesRanking"
    >
      <p class="factory-product-item-top__factory">
        FACTORY
      </p>
      <p class="factory-product-item-top__sales">
        SALES
      </p>
      <div class="factory-product-item-top__content">
        <p class="factory-product-item-top__top">
          TOP.
        </p>
        <p class="factory-product-item-top__num">
          0{{ item.salesRanking }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Image } from '@/components/Image'
import { IntlCurrency } from '@/components/NewIntlCurrency'
import { useCurrencyStore } from '@/pinia/currency'
import { bankersRoundWithMax, formatSalesVolume } from '@/utils/utils'

defineProps({
  item: {
    type: Object,
    required: true
  }
})

const currency = useCurrencyStore()

const productPrice = (item) => {
  const rate = currency.current.rate || 1
  return bankersRoundWithMax(item.priceInfo.price * rate, 0.01)
}
</script>

<style lang="less">
.factory-product-item {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #EBF1F5;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;

  &__thumbnail {
    flex-shrink: 0;
    width: 100%;
    aspect-ratio: 1;
    overflow: hidden;
  }

  &__image {
    width: 100%;
    height: 100%;
    transition: all .2s ease-in-out;
  }

  &__content {
    padding: 12px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &__title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;

    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
  }

  &__cell {
    margin-top: auto;
    padding-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__price {
    display: flex;
    align-items: center;
    font-family: mon-700;
    font-size: 16px;
    line-height: 24px;
  }

  &__sold {
    font-family: mon-500;
    font-size: 11px;
    line-height: 14px;
    text-align: right;
    color: #6E717A;
  }

  &:hover  &__image {
    transform: scale(1.2);
  }

  &-top {
    position: absolute;
    top: 0;
    left: 8px;
    padding: 8px;
    background-color: #FEF6E6;
    color: #D25123;
    text-align: center;
    aspect-ratio: 0.698;
    clip-path: shape(from 50% 100%,curve to 100% 65.12% with 77.61% 100%/100% 84.38%,vline to 0%,hline to 0%,vline to 65.12%,curve to 50% 100% with 0% 84.38%/22.39% 100%,close);

    &__factory {
      font-family: mon-600;
      font-size: 7.5px;
      line-height: 8px;
    }

    &__sales {
      font-family: mon-700;
      font-size: 11px;
      line-height: 14px;
    }

    &__content {
      margin-top: 4px;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background-color: #FFFFFF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &__top {
      font-family: mon-600;
      font-size: 9px;
      line-height: 10px;
    }

    &__num {
      font-family: mon-700;
      font-size: 24px;
      line-height: 24px;
    }
  }
}
</style>
